'use strict';

export default {
  'AD': {
    'name': 'Andorra',
    'placeId': 'ChIJlfCemC71pRIRkn_qeNc-yQc',
    'currency': 'EUR'
  },
  'AE': {
    'name': 'United Arab Emirates',
    'placeId': 'ChIJvRKrsd9IXj4RpwoIwFYv0zM',
    'currency': 'AED'
  },
  'AF': {
    'name': 'Afghanistan',
    'placeId': 'ChIJbQL_-LZu0TgReNqWvg1GtfM',
    'currency': 'USD'
  },
  'AG': {
    'name': 'Antigua and Barbuda',
    'placeId': 'ChIJwdG4bbluDYwRlHmL4Yg3aic',
    'currency': 'USD'
  },
  'AI': {
    'name': 'Anguilla',
    'placeId': 'ChIJ5QHvjnRjDowRgdTghNNqnTs',
    'currency': 'USD'
  },
  'AL': {
    'name': 'Albania',
    'placeId': 'ChIJLUwnvfM7RRMR7juY1onlfAc',
    'currency': 'EUR'
  },
  'AM': {
    'name': 'Armenia',
    'placeId': 'ChIJx7pz54RWFUARIy2C63p1tNA',
    'currency': 'EUR'
  },
  'AO': {
    'name': 'Angola',
    'placeId': 'ChIJJ4utyk7yURoRPU5KDZ0oClk',
    'currency': 'USD'
  },
  'AQ': {
    'name': 'Antarctica',
    'placeId': 'ChIJS3WQM3uWuaQRdSAPdB--Um4',
    'currency': 'USD'
  },
  'AR': {
    'name': 'Argentina',
    'placeId': 'ChIJZ8b99fXKvJURqA_wKpl3Lz0',
    'currency': 'USD'
  },
  'AS': {
    'name': 'American Samoa',
    'placeId': 'ChIJyf1IkreEpnER3UuuLZ5z7vM',
    'currency': 'USD'
  },
  'AT': {
    'name': 'Austria',
    'placeId': 'ChIJfyqdJZsHbUcRr8Hk3XvUEhA',
    'currency': 'EUR'
  },
  'AU': {
    'name': 'Australia',
    'placeId': 'ChIJ38WHZwf9KysRUhNblaFnglM',
    'currency': 'AUD'
  },
  'AW': {
    'name': 'Aruba',
    'placeId': 'ChIJ23da4s84hY4RL4yBiT6KavE',
    'currency': 'USD'
  },
  'AX': {
    'name': 'Aland Islands',
    'placeId': 'ChIJGevhxGjkikYR7Y5Cc4P2Q80',
    'currency': 'EUR'
  },
  'AZ': {
    'name': 'Azerbaijan',
    'placeId': 'ChIJ3x2iGtl8MEARCM2DPmtSyeY',
    'currency': 'EUR'
  },
  'BA': {
    'name': 'Bosnia and Herzegovina',
    'placeId': 'ChIJ16k3xxWiSxMRDOm3QwPi920',
    'currency': 'EUR'
  },
  'BB': {
    'name': 'Barbados',
    'placeId': 'ChIJoxoyrvvxQ4wRKzb0jLNR7A4',
    'currency': 'USD'
  },
  'BD': {
    'name': 'Bangladesh',
    'placeId': 'ChIJp4vhgO2qrTARa_zhxOAoLQ8',
    'currency': 'USD'
  },
  'BE': {
    'name': 'Belgium',
    'placeId': 'ChIJl5fz7WR9wUcR8g_mObTy60c',
    'currency': 'EUR'
  },
  'BF': {
    'name': 'Burkina Faso',
    'placeId': 'ChIJm3Cm1SbKLQ4Rq22DRu0Kkyc',
    'currency': 'USD'
  },
  'BG': {
    'name': 'Bulgaria',
    'placeId': 'ChIJifBbyMH-qEAREEy_aRKgAAA',
    'currency': 'EUR'
  },
  'BH': {
    'name': 'Bahrain',
    'placeId': 'ChIJEaJHak5SSD4RRhDa2-JQlC4',
    'currency': 'USD'
  },
  'BI': {
    'name': 'Burundi',
    'placeId': 'ChIJW_FUNtNEwRkRjewxVg5NI7E',
    'currency': 'USD'
  },
  'BJ': {
    'name': 'Benin',
    'placeId': 'ChIJlVZ6BCtUIxAR9S5iy_h3suw',
    'currency': 'USD'
  },
  'BL': {
    'name': 'St Barthélemy',
    'placeId': 'ChIJnej-KlR1DowR5nUq6msRdAE',
    'currency': 'USD'
  },
  'BM': {
    'name': 'Bermuda',
    'placeId': 'ChIJpbBohp4TLYoRvLiZLMf93zw',
    'currency': 'USD'
  },
  'BN': {
    'name': 'Brunei',
    'placeId': 'ChIJ0bm4BEuZGDIR1toJ3YA1_l0',
    'currency': 'USD'
  },
  'BQ': {
    'name': 'Caribbean Netherlands',
    'placeId': 'ChIJt7kdj4sYIowRz7WDIdc1beE',
    'currency': 'USD'
  },
  'BR': {
    'name': 'Brazil',
    'placeId': 'ChIJzyjM68dZnAARYz4p8gYVWik',
    'currency': 'USD'
  },
  'BS': {
    'name': 'The Bahamas',
    'placeId': 'ChIJPQ9Isjua1ogR5XnHaoO0PhM',
    'currency': 'USD'
  },
  'BT': {
    'name': 'Bhutan',
    'placeId': 'ChIJz5XFc6WSWzcR2rw2KGWsDLs',
    'currency': 'USD'
  },
  'BV': {
    'name': 'Bouvet Island',
    'placeId': 'ChIJP747leE0g7cRS7j-ENe4oLY',
    'currency': 'USD'
  },
  'BW': {
    'name': 'Botswana',
    'placeId': 'ChIJESJF0SFDpB4Re68Vhyp8ZPE',
    'currency': 'USD'
  },
  'BY': {
    'name': 'Belarus',
    'placeId': 'ChIJgUit4oQl2kYREIzsgdGhAAA',
    'currency': 'EUR'
  },
  'BZ': {
    'name': 'Belize',
    'placeId': 'ChIJ-foSwT5bXI8RTuMeP02KSvY',
    'currency': 'USD'
  },
  'CA': {
    'name': 'Canada',
    'placeId': 'ChIJ2WrMN9MDDUsRpY9Doiq3aJk',
    'currency': 'CAD'
  },
  'CF': {
    'name': 'Central African Republic',
    'placeId': 'ChIJt6KGjVPpuBARJIBcWgLGm7g',
    'currency': 'USD'
  },
  'CG': {
    'name': 'Congo',
    'placeId': 'ChIJCROj3WOlYBoRj2z8FM96AVU',
    'currency': 'USD'
  },
  'CH': {
    'name': 'Switzerland',
    'placeId': 'ChIJYW1Zb-9kjEcRFXvLDxG1Vlw',
    'currency': 'CHF'
  },
  'CI': {
    'name': 'Côte d\'Ivoire',
    'placeId': 'ChIJZ6BJsIcTlg8RQO65fGIe-QE',
    'currency': 'USD'
  },
  'CK': {
    'name': 'Cook Islands',
    'placeId': 'ChIJ3d57ue-KVHER2LQIiA6lTAI',
    'currency': 'USD'
  },
  'CL': {
    'name': 'Chile',
    'placeId': 'ChIJL68lBEHFYpYRHbkCERPhBQU',
    'currency': 'USD'
  },
  'CM': {
    'name': 'Cameroon',
    'placeId': 'ChIJIQ8-cFM3YRARU5uCmUXEAys',
    'currency': 'USD'
  },
  'CN': {
    'name': 'China',
    'placeId': 'ChIJwULG5WSOUDERbzafNHyqHZU',
    'currency': 'CNY'
  },
  'CO': {
    'name': 'Colombia',
    'placeId': 'ChIJo5QVrjqkFY4RQKPy7wSaDZo',
    'currency': 'USD'
  },
  'CR': {
    'name': 'Costa Rica',
    'placeId': 'ChIJJcmsIWLlko8RK5qBNSX3VGI',
    'currency': 'USD'
  },
  'CU': {
    'name': 'Cuba',
    'placeId': 'ChIJtUx6DwdJzYgRGqQQkVL3jHk',
    'currency': 'USD'
  },
  'CV': {
    'name': 'Cape Verde',
    'placeId': 'ChIJMVERWSGPNQkRH-oY-TbyGms',
    'currency': 'USD'
  },
  'CW': {
    'name': 'Curaçao',
    'placeId': 'ChIJx_3HYr6dhI4RI0fG2yiSf_w',
    'currency': 'USD'
  },
  'CY': {
    'name': 'Cyprus',
    'placeId': 'ChIJVU1JymcX3hQRbhTEf4A8TDI',
    'currency': 'EUR'
  },
  'CZ': {
    'name': 'Czech Republic',
    'placeId': 'ChIJQ4Ld14-UC0cRb1jb03UcZvg',
    'currency': 'EUR'
  },
  'DE': {
    'name': 'Germany',
    'placeId': 'ChIJa76xwh5ymkcRW-WRjmtd6HU',
    'currency': 'EUR'
  },
  'DJ': {
    'name': 'Djibouti',
    'placeId': 'ChIJAfb5NGfUIhYRiFsP76e7chQ',
    'currency': 'USD'
  },
  'DK': {
    'name': 'Denmark',
    'placeId': 'ChIJ-1-U7rYnS0YRzZLgw9BDh1I',
    'currency': 'DKK'
  },
  'DO': {
    'name': 'Dominican Republic',
    'placeId': 'ChIJ9bbx3jiIr44R4PcNBiQPAqY',
    'currency': 'USD'
  },
  'DZ': {
    'name': 'Algeria',
    'placeId': 'ChIJ0XsDKGqKfg0RovjXq-O-QHE',
    'currency': 'USD'
  },
  'EC': {
    'name': 'Ecuador',
    'placeId': 'ChIJ1UuaqN2HI5ARAjecEQSvdp0',
    'currency': 'USD'
  },
  'EE': {
    'name': 'Estonia',
    'placeId': 'ChIJ_UuggpyUkkYRwyW0T7qf6kA',
    'currency': 'EUR'
  },
  'EG': {
    'name': 'Egypt',
    'placeId': 'ChIJ6TZcw3aJNhQRRMTEJQmgRSw',
    'currency': 'EUR'
  },
  'ER': {
    'name': 'Eritrea',
    'placeId': 'ChIJZYW6nT9abRYR-g4SL_AIwhc',
    'currency': 'USD'
  },
  'ES': {
    'name': 'Spain',
    'placeId': 'ChIJi7xhMnjjQgwR7KNoB5Qs7KY',
    'currency': 'EUR'
  },
  'ET': {
    'name': 'Ethiopia',
    'placeId': 'ChIJK_1s3c7QNRYRWsVIU3-m9ns',
    'currency': 'USD'
  },
  'FI': {
    'name': 'Finland',
    'placeId': 'ChIJ3fYyS9_KgUYREKh1PNZGAQA',
    'currency': 'EUR'
  },
  'FJ': {
    'name': 'Fiji',
    'placeId': 'ChIJXdw8cP2QGW4Rk1vvRpkxnJ4',
    'currency': 'USD'
  },
  'FO': {
    'name': 'Faroe Islands',
    'placeId': 'ChIJ6_ktdpMVvEgRJBv3ZEgxsD8',
    'currency': 'USD'
  },
  'FR': {
    'name': 'France',
    'placeId': 'ChIJMVd4MymgVA0R99lHx5Y__Ws',
    'currency': 'EUR'
  },
  'GA': {
    'name': 'Gabon',
    'placeId': 'ChIJ7fM4VIo7fxARFWt4Ng7DDHs',
    'currency': 'USD'
  },
  'GB': {
    'name': 'United Kingdom',
    'placeId': 'ChIJqZHHQhE7WgIReiWIMkOg-MQ',
    'currency': 'GBP'
  },
  'GD': {
    'name': 'Grenada',
    'placeId': 'ChIJ0XuH9IkXOIwRjk8fWgHH2DY',
    'currency': 'USD'
  },
  'GE': {
    'name': 'Georgia',
    'placeId': 'ChIJa2JP5tcMREARwkotEmR5kE8',
    'currency': 'USD'
  },
  'GF': {
    'name': 'French Guiana',
    'placeId': 'ChIJU9f3hVcVEo0RRvQKD-n3J94',
    'currency': 'USD'
  },
  'GG': {
    'name': 'Guernsey',
    'placeId': 'ChIJ7bO_9OQgDUgRmZgNXYrVCpk',
    'currency': 'USD'
  },
  'GH': {
    'name': 'Ghana',
    'placeId': 'ChIJx9baqM1a1w8RNtKT0DDy11Q',
    'currency': 'USD'
  },
  'GI': {
    'name': 'Gibraltar',
    'placeId': 'ChIJNb4UJ3a_DA0RD4cANiYlTjg',
    'currency': 'EUR'
  },
  'GL': {
    'name': 'Greenland',
    'placeId': 'ChIJFXfA47sNok4RGOIUAYOdzzQ',
    'currency': 'USD'
  },
  'GM': {
    'name': 'The Gambia',
    'placeId': 'ChIJBzivZSmcwg4RKp0Ta0BMSp4',
    'currency': 'USD'
  },
  'GN': {
    'name': 'Guinea',
    'placeId': 'ChIJP5XOvCGzAQ8R9i1a18t7c-g',
    'currency': 'USD'
  },
  'GP': {
    'name': 'Guadeloupe',
    'placeId': 'ChIJUX0od1p1DowRqwdKtzc-vuw',
    'currency': 'USD'
  },
  'GQ': {
    'name': 'Equatorial Guinea',
    'placeId': 'ChIJp4euX2A6ZBARet4QLKKicMg',
    'currency': 'USD'
  },
  'GR': {
    'name': 'Greece',
    'placeId': 'ChIJY2xxEcdKWxMRHS2a3HUXOjY',
    'currency': 'EUR'
  },
  'GS': {
    'name': 'South Georgia and the South Sandwich Islands',
    'placeId': 'ChIJJXmoUuK2PbkRvbBNiNp8434',
    'currency': 'USD'
  },
  'GT': {
    'name': 'Guatemala',
    'placeId': 'ChIJa1DnNlATiIURu9WEWzcrmDU',
    'currency': 'USD'
  },
  'GU': {
    'name': 'Guam',
    'placeId': 'ChIJ7yQPk_92H2cRpuWzxZGucVU',
    'currency': 'USD'
  },
  'GW': {
    'name': 'Guinea-Bissau',
    'placeId': 'ChIJ8amCr3Q85A4RTggeVz-O6Ls',
    'currency': 'USD'
  },
  'GY': {
    'name': 'Guyana',
    'placeId': 'ChIJs8LYYK_vr40RQETltmeI40g',
    'currency': 'USD'
  },
  'HK': {
    'name': 'Hong Kong',
    'placeId': 'ChIJD5gyo-3iAzQRfMnq27qzivA',
    'currency': 'HKD'
  },
  'HN': {
    'name': 'Honduras',
    'placeId': 'ChIJzzG3cxp1ao8RZIL7toLe0X4',
    'currency': 'USD'
  },
  'HR': {
    'name': 'Croatia',
    'placeId': 'ChIJ7ZXdCghBNBMRfxtm4STA86A',
    'currency': 'EUR'
  },
  'HT': {
    'name': 'Haiti',
    'placeId': 'ChIJEbvLf_PGto4R0_ZUTLI4FLU',
    'currency': 'USD'
  },
  'HU': {
    'name': 'Hungary',
    'placeId': 'ChIJw-Q333uDQUcREBAeDCnEAAA',
    'currency': 'EUR'
  },
  'ID': {
    'name': 'Indonesia',
    'placeId': 'ChIJtwRkSdcHTCwRhfStG-dNe-M',
    'currency': 'IDR'
  },
  'IE': {
    'name': 'Ireland',
    'placeId': 'ChIJ-ydAXOS6WUgRCPTbzjQSfM8',
    'currency': 'EUR'
  },
  'IL': {
    'name': 'Israel',
    'placeId': 'ChIJi8mnMiRJABURuiw1EyBCa2o',
    'currency': 'ILS'
  },
  'IM': {
    'name': 'Isle of Man',
    'placeId': 'ChIJ1YEuRDCFY0gRDeDw8bxbAuo',
    'currency': 'USD'
  },
  'IN': {
    'name': 'India',
    'placeId': 'ChIJkbeSa_BfYzARphNChaFPjNc',
    'currency': 'INR'
  },
  'IO': {
    'name': 'British Indian Ocean Territory',
    'placeId': 'ChIJh6OdhOBzkiQR4WsfEHBkT6k',
    'currency': 'USD'
  },
  'IQ': {
    'name': 'Iraq',
    'placeId': 'ChIJEUr1VD2CVxURAhYGorthpW0',
    'currency': 'USD'
  },
  'IS': {
    'name': 'Iceland',
    'placeId': 'ChIJQ2Dro1Ir0kgRmkXB5TQEim8',
    'currency': 'EUR'
  },
  'IT': {
    'name': 'Italy',
    'placeId': 'ChIJA9KNRIL-1BIRb15jJFz1LOI',
    'currency': 'EUR'
  },
  'JE': {
    'name': 'Jersey',
    'placeId': 'ChIJM3WSjKRSDEgRw2waCqMjnFE',
    'currency': 'USD'
  },
  'JM': {
    'name': 'Jamaica',
    'placeId': 'ChIJnXHPxhsq2o4R-g4StcDRoFk',
    'currency': 'USD'
  },
  'JO': {
    'name': 'Jordan',
    'placeId': 'ChIJmd5kZkdvABURmU4mUQdbKI0',
    'currency': 'USD'
  },
  'JP': {
    'name': 'Japan',
    'placeId': 'ChIJLxl_1w9OZzQRRFJmfNR1QvU',
    'currency': 'JPY'
  },
  'KE': {
    'name': 'Kenya',
    'placeId': 'ChIJD5BQg9CAJxgR2W2XobAOO0A',
    'currency': 'USD'
  },
  'KG': {
    'name': 'Kyrgyzstan',
    'placeId': 'ChIJ8yfp_B04lzgRM8SITrdYECg',
    'currency': 'USD'
  },
  'KH': {
    'name': 'Cambodia',
    'placeId': 'ChIJQzfc1L-HBzERUxL0ieC_t-Q',
    'currency': 'USD'
  },
  'KI': {
    'name': 'Kiribati',
    'placeId': 'ChIJA4cCwpF8ZGURB8NSAQR9MoQ',
    'currency': 'USD'
  },
  'KM': {
    'name': 'Comoros',
    'placeId': 'ChIJjaQIZAPjmBgR29Tf5L5_Cvc',
    'currency': 'USD'
  },
  'KN': {
    'name': 'St Kitts and Nevis',
    'placeId': 'ChIJDXKKxm4ZEowR6IYdmsaa6d4',
    'currency': 'USD'
  },
  'KW': {
    'name': 'Kuwait',
    'placeId': 'ChIJoVHqvj82xT8R0u3Yks1rcnQ',
    'currency': 'USD'
  },
  'KY': {
    'name': 'Cayman Islands',
    'placeId': 'ChIJKaq4Lz6GJY8RXnFwh9PERXA',
    'currency': 'USD'
  },
  'KZ': {
    'name': 'Kazakhstan',
    'placeId': 'ChIJR6n87AcQqTgRGw6z5C-Ee18',
    'currency': 'USD'
  },
  'LA': {
    'name': 'Laos',
    'placeId': 'ChIJiUWCsFeQFDERgc2ZH0iSxQ4',
    'currency': 'USD'
  },
  'LB': {
    'name': 'Lebanon',
    'placeId': 'ChIJraoihAIXHxURcPkAbAk0fcw',
    'currency': 'USD'
  },
  'LC': {
    'name': 'St Lucia',
    'placeId': 'ChIJHaMt8WVgQIwR9Z056MSGdG4',
    'currency': 'USD'
  },
  'LI': {
    'name': 'Liechtenstein',
    'placeId': 'ChIJ_S9HHUQxm0cRibFa3Ta16mA',
    'currency': 'CHF'
  },
  'LK': {
    'name': 'Sri Lanka',
    'placeId': 'ChIJnR5a9jxZ4joRjNPiALSkPeE',
    'currency': 'USD'
  },
  'LR': {
    'name': 'Liberia',
    'placeId': 'ChIJwfyp1AP4CQ8Rc2PRMmso038',
    'currency': 'USD'
  },
  'LS': {
    'name': 'Lesotho',
    'placeId': 'ChIJ64xf1idIjB4Rsx7ReLhXLSM',
    'currency': 'USD'
  },
  'LT': {
    'name': 'Lithuania',
    'placeId': 'ChIJE74zDxSU3UYRubpdpdNUCvM',
    'currency': 'EUR'
  },
  'LU': {
    'name': 'Luxembourg',
    'placeId': 'ChIJRyEhyrlFlUcR75LTAvZg22Q',
    'currency': 'EUR'
  },
  'LV': {
    'name': 'Latvia',
    'placeId': 'ChIJ_ZqKe2cw6UYREPzyaM3PAAA',
    'currency': 'EUR'
  },
  'LY': {
    'name': 'Libya',
    'placeId': 'ChIJDQHOjtmSqBMRKsL5x0FgB_o',
    'currency': 'USD'
  },
  'MA': {
    'name': 'Morocco',
    'placeId': 'ChIJjcVRlmGICw0Rw_8sxIGT09k',
    'currency': 'USD'
  },
  'MC': {
    'name': 'Monaco',
    'placeId': 'ChIJMYU_e2_CzRIR_JzEOkx493Q',
    'currency': 'EUR'
  },
  'ME': {
    'name': 'Montenegro',
    'placeId': 'ChIJyx8sJBcyTBMRRtP_boadTDg',
    'currency': 'EUR'
  },
  'MG': {
    'name': 'Madagascar',
    'placeId': 'ChIJRYUj6uOk0SERiBN7l8HjRFI',
    'currency': 'USD'
  },
  'MH': {
    'name': 'Marshall Islands',
    'placeId': 'ChIJK8opIbIZAWURdrcJqugDPos',
    'currency': 'USD'
  },
  'ML': {
    'name': 'Mali',
    'placeId': 'ChIJz3MQG4g-FA4RgM-9oOJbOrs',
    'currency': 'USD'
  },
  'MM': {
    'name': 'Republic of the Union of Myanmar',
    'placeId': 'ChIJBylOcadSVjAREStiHOQOe7o',
    'currency': 'USD'
  },
  'MN': {
    'name': 'Mongolia',
    'placeId': 'ChIJS22qaQYFJzYRluDmNzkh3eA',
    'currency': 'USD'
  },
  'MO': {
    'name': 'Macau',
    'placeId': 'ChIJ88g14uB6ATQR9qyFtCzje8Y',
    'currency': 'USD'
  },
  'MP': {
    'name': 'Northern Mariana Islands',
    'placeId': 'ChIJUVyZkDSx2GYRMg46fKvrt50',
    'currency': 'USD'
  },
  'MQ': {
    'name': 'Martinique',
    'placeId': 'ChIJDQdmAPmgaowRsOevFxIbAOE',
    'currency': 'USD'
  },
  'MR': {
    'name': 'Mauritania',
    'placeId': 'ChIJTzmzFMO4gA4RTlO-1usLIoM',
    'currency': 'USD'
  },
  'MS': {
    'name': 'Montserrat',
    'placeId': 'ChIJnTbH4VOrE4wRorEFiIPqDx4',
    'currency': 'USD'
  },
  'MT': {
    'name': 'Malta',
    'placeId': 'ChIJxUeGHShFDhMROUK-NmHYgvU',
    'currency': 'EUR'
  },
  'MU': {
    'name': 'Mauritius',
    'placeId': 'ChIJyXRE-U1QfCERMdBrEcLZA0I',
    'currency': 'USD'
  },
  'MV': {
    'name': 'Maldives',
    'placeId': 'ChIJvXv7qr-ZtSQRiWKVgeEJRUE',
    'currency': 'USD'
  },
  'MW': {
    'name': 'Malawi',
    'placeId': 'ChIJ18ATk91b2BgRQ4VmKRcuo0Q',
    'currency': 'USD'
  },
  'MX': {
    'name': 'Mexico',
    'placeId': 'ChIJU1NoiDs6BIQREZgJa760ZO0',
    'currency': 'MXN'
  },
  'MY': {
    'name': 'Malaysia',
    'placeId': 'ChIJrzBnX5fTNDAR2BwhKJOWRQc',
    'currency': 'USD'
  },
  'MZ': {
    'name': 'Mozambique',
    'placeId': 'ChIJxUr95uqs1BgRFaEWrrm_uxI',
    'currency': 'USD'
  },
  'NA': {
    'name': 'Namibia',
    'placeId': 'ChIJIXXTbn489RsRYbLsqKXludM',
    'currency': 'USD'
  },
  'NC': {
    'name': 'New Caledonia',
    'placeId': 'ChIJyzIaP2niJ2wR7HqT1Y_20PY',
    'currency': 'USD'
  },
  'NG': {
    'name': 'Nigeria',
    'placeId': 'ChIJDY2kfa8LThARyAvFaEH-qJk',
    'currency': 'USD'
  },
  'NF': {
    'name': 'Norfolk Island',
    'placeId': 'ChIJOcm6rR_RS2wRUhVdMyOYerk',
    'currency': 'USD'
  },
  'NI': {
    'name': 'Nicaragua',
    'placeId': 'ChIJzSL_zgDCEI8RtRWsP-Wn-sg',
    'currency': 'USD'
  },
  'NL': {
    'name': 'Netherlands',
    'placeId': 'ChIJu-SH28MJxkcRnwq9_851obM',
    'currency': 'USD'
  },
  'NO': {
    'name': 'Norway',
    'placeId': 'ChIJv-VNj0VoEkYRK9BkuJ07sKE',
    'currency': 'NOK'
  },
  'NP': {
    'name': 'Nepal',
    'placeId': 'ChIJz2gufcfolTkR3obM0LyaojQ',
    'currency': 'USD'
  },
  'NR': {
    'name': 'Nauru',
    'placeId': 'ChIJTVvkHR8cfW8RgQrUxfSd2Vk',
    'currency': 'USD'
  },
  'NU': {
    'name': 'Niue',
    'placeId': 'ChIJO7duNyolnXERGIvcezR4QpE',
    'currency': 'USD'
  },
  'NZ': {
    'name': 'New Zealand',
    'placeId': 'ChIJh5Z3Fw4gLG0RM0dqdeIY1rE',
    'currency': 'NZD'
  },
  'OM': {
    'name': 'Oman',
    'placeId': 'ChIJv5vVqWaf1j0RF6ixZXZMBjo',
    'currency': 'USD'
  },
  'PA': {
    'name': 'Panama',
    'placeId': 'ChIJ4yu-yIMVpo8Rz5ulH03g7nk',
    'currency': 'USD'
  },
  'PE': {
    'name': 'Peru',
    'placeId': 'ChIJ9RRZwFDIBZERSAYheRIBnvI',
    'currency': 'USD'
  },
  'PF': {
    'name': 'French Polynesia',
    'placeId': 'ChIJTddtfNB1GHQREVfDCXp6wJs',
    'currency': 'USD'
  },
  'PG': {
    'name': 'Papua New Guinea',
    'placeId': 'ChIJr54Ov6_oWWgRehKcjg3l8No',
    'currency': 'USD'
  },
  'PH': {
    'name': 'Philippines',
    'placeId': 'ChIJY96HXyFTQDIRV9opeu-QR3g',
    'currency': 'USD'
  },
  'PK': {
    'name': 'Pakistan',
    'placeId': 'ChIJH3X9-NJS2zgRXJIU5veht0Y',
    'currency': 'USD'
  },
  'PL': {
    'name': 'Poland',
    'placeId': 'ChIJuwtkpGSZAEcR6lXMScpzdQk',
    'currency': 'EUR'
  },
  'PM': {
    'name': 'St Pierre and Miquelon',
    'placeId': 'ChIJ0VcO-0tLbEsREVxs6jdncZw',
    'currency': 'USD'
  },
  'PN': {
    'name': 'Pitcairn Islands',
    'placeId': 'ChIJiweo3H8POJ4RyJoVGceMnEY',
    'currency': 'USD'
  },
  'PR': {
    'name': 'Puerto Rico',
    'placeId': 'ChIJ-aeSGyaWAowRGpsEGCjsNvM',
    'currency': 'USD'
  },
  'PT': {
    'name': 'Portugal',
    'placeId': 'ChIJ1SZCvy0kMgsRQfBOHAlLuCo',
    'currency': 'EUR'
  },
  'PW': {
    'name': 'Palau',
    'placeId': 'ChIJmQOvorRFhDIRu-uhOd0e7RI',
    'currency': 'USD'
  },
  'PY': {
    'name': 'Paraguay',
    'placeId': 'ChIJYz3xkDQIXJQR8y5YHWH_-rM',
    'currency': 'USD'
  },
  'QA': {
    'name': 'Qatar',
    'placeId': 'ChIJf-jc_zTFRT4RMkArgc-I-hw',
    'currency': 'USD'
  },
  'RE': {
    'name': 'Reunion',
    'placeId': 'ChIJO-S4EIF3eCER-erb7ImOf0o',
    'currency': 'USD'
  },
  'RO': {
    'name': 'Romania',
    'placeId': 'ChIJw3aJlSb_sUARlLEEqJJP74Q',
    'currency': 'EUR'
  },
  'RS': {
    'name': 'Serbia',
    'placeId': 'ChIJlYCJ8t8dV0cRXYYjN-pQXgU',
    'currency': 'EUR'
  },
  'RU': {
    'name': 'Russia',
    'placeId': 'ChIJ-yRniZpWPEURE_YRZvj9CRQ',
    'currency': 'RUB'
  },
  'RW': {
    'name': 'Rwanda',
    'placeId': 'ChIJ40A451SWwhkRA6HMyyawkHQ',
    'currency': 'USD'
  },
  'SA': {
    'name': 'Saudi Arabia',
    'placeId': 'ChIJQSqV5z-z5xURm7YawktQYFk',
    'currency': 'SAR'
  },
  'SB': {
    'name': 'Solomon Islands',
    'placeId': 'ChIJ0QlQVeBR02gRgClEF6DATLQ',
    'currency': 'USD'
  },
  'SC': {
    'name': 'Seychelles',
    'placeId': 'ChIJO62-cP0hXCIR99pJ06DQ0zI',
    'currency': 'USD'
  },
  'SD': {
    'name': 'Sudan',
    'placeId': 'ChIJlbFyEMQc2RURNythKkZwv9I',
    'currency': 'USD'
  },
  'SE': {
    'name': 'Sweden',
    'placeId': 'ChIJ8fA1bTmyXEYRYm-tjaLruCI',
    'currency': 'SEK'
  },
  'SG': {
    'name': 'Singapore',
    'placeId': 'ChIJdZOLiiMR2jERxPWrUs9peIg',
    'currency': 'USD'
  },
  'SI': {
    'name': 'Slovenia',
    'placeId': 'ChIJYYOWXuckZUcRZdTiJR5FQOc',
    'currency': 'EUR'
  },
  'SJ': {
    'name': 'Svalbard and Jan Mayen',
    'placeId': 'ChIJgQmY0JVjd0URQdKkzJ42A4U',
    'currency': 'USD'
  },
  'SK': {
    'name': 'Slovakia',
    'placeId': 'ChIJf8Z8rrlgFEcRfTpysWdha80',
    'currency': 'EUR'
  },
  'SL': {
    'name': 'Sierra Leone',
    'placeId': 'ChIJQ_OrOhgGAQ8RGfcsx83paVM',
    'currency': 'USD'
  },
  'SM': {
    'name': 'San Marino',
    'placeId': 'ChIJeT_m9V_rLBMRECA0gpnzAAA',
    'currency': 'EUR'
  },
  'SN': {
    'name': 'Senegal',
    'placeId': 'ChIJcbvFs_VywQ4RQFlhmVClRlo',
    'currency': 'USD'
  },
  'SO': {
    'name': 'Somalia',
    'placeId': 'ChIJg1vR7KcuHRgRvuXpXM46OZ4',
    'currency': 'USD'
  },
  'SR': {
    'name': 'Suriname',
    'placeId': 'ChIJUdXT2dU2CI0RsjYpccDhNxA',
    'currency': 'USD'
  },
  'SS': {
    'name': 'South Sudan',
    'placeId': 'ChIJGTE-PbUwGRcRl7y2fmND8Ns',
    'currency': 'USD'
  },
  'ST': {
    'name': 'São Tomé and Príncipe',
    'placeId': 'ChIJidiaC_nscBAR6jB2VQwjUWI',
    'currency': 'USD'
  },
  'SV': {
    'name': 'El Salvador',
    'placeId': 'ChIJVwZkWaYnY48RMkiFmOsWmm8',
    'currency': 'USD'
  },
  'SY': {
    'name': 'Syria',
    'placeId': 'ChIJp8Y8QdzmGBURIPYqiPRGdYc',
    'currency': 'USD'
  },
  'SZ': {
    'name': 'Swaziland',
    'placeId': 'ChIJBw8yR-HO6B4RaXANGC_GPcE',
    'currency': 'USD'
  },
  'TC': {
    'name': 'Turks and Caicos Islands',
    'placeId': 'ChIJdWu7vlVfS4kR3sGNAoDHEX4',
    'currency': 'USD'
  },
  'TD': {
    'name': 'Chad',
    'placeId': 'ChIJYXNnvXg55xARnIDAzluDYDs',
    'currency': 'USD'
  },
  'TF': {
    'name': 'French Southern and Antarctic Lands',
    'placeId': 'ChIJN8QJBD7EFLMRKdDmkEwhirg',
    'currency': 'USD'
  },
  'TG': {
    'name': 'Togo',
    'placeId': 'ChIJGVQYE8HhIxARYJPRGjBbrvo',
    'currency': 'USD'
  },
  'TH': {
    'name': 'Thailand',
    'placeId': 'ChIJsU1CR_eNTTARAuhXB4gs154',
    'currency': 'USD'
  },
  'TJ': {
    'name': 'Tajikistan',
    'placeId': 'ChIJzbO8enN2sTgRtYgZT4QxwyU',
    'currency': 'USD'
  },
  'TK': {
    'name': 'Tokelau',
    'placeId': 'ChIJ9x14s6omUnARN5vbbUZicI8',
    'currency': 'USD'
  },
  'TL': {
    'name': 'Timor-Leste',
    'placeId': 'ChIJKaHkhgnl_SwRPFvoh4PG5QM',
    'currency': 'USD'
  },
  'TM': {
    'name': 'Turkmenistan',
    'placeId': 'ChIJy2y8dFXLZT8RkaRpQWuC3X4',
    'currency': 'USD'
  },
  'TN': {
    'name': 'Tunisia',
    'placeId': 'ChIJ4aQWg0SVVRIR75sBqjozhDo',
    'currency': 'USD'
  },
  'TO': {
    'name': 'Tonga',
    'placeId': 'ChIJHdCfu0S2k3ERqeJexcrMbfM',
    'currency': 'USD'
  },
  'TR': {
    'name': 'Turkey',
    'placeId': 'ChIJcSZPllwVsBQRKl9iKtTb2UA',
    'currency': 'TRY'
  },
  'TT': {
    'name': 'Trinidad and Tobago',
    'placeId': 'ChIJxbZQY5cHNowRJ_E5xlUoCP8',
    'currency': 'USD'
  },
  'TV': {
    'name': 'Tuvalu',
    'placeId': 'ChIJTaCxWbmcwW8RLhIHB2hUZ48',
    'currency': 'USD'
  },
  'UA': {
    'name': 'Ukraine',
    'placeId': 'ChIJjw5wVMHZ0UAREED2iIQGAQA',
    'currency': 'EUR'
  },
  'UG': {
    'name': 'Uganda',
    'placeId': 'ChIJRfmZZJ-mcRcRSUUBQ85VQYc',
    'currency': 'USD'
  },
  'UM': {
    'name': 'United States Minor Outlying Islands',
    'placeId': 'ChIJBQ-2twOlemQREDZxw68t4QQ',
    'currency': 'USD'
  },
  'US': {
    'name': 'United States',
    'placeId': 'ChIJCzYy5IS16lQRQrfeQ5K5Oxw',
    'currency': 'USD'
  },
  'UY': {
    'name': 'Uruguay',
    'placeId': 'ChIJCd5f-zoHdZURSlIWYGGWVUo',
    'currency': 'USD'
  },
  'UZ': {
    'name': 'Uzbekistan',
    'placeId': 'ChIJsXbWpSCLrjgRIB6Efq1tCso',
    'currency': 'USD'
  },
  'VA': {
    'name': 'Vatican City',
    'placeId': 'ChIJPS3UVwqJJRMRsH46sppPCQA',
    'currency': 'EUR'
  },
  'VC': {
    'name': 'St Vincent and the Grenadines',
    'placeId': 'ChIJuzU5nuKsQIwRsaHSjejT_TE',
    'currency': 'USD'
  },
  'VN': {
    'name': 'Vietnam',
    'placeId': 'ChIJXx5qc016FTERvmL-4smwO7A',
    'currency': 'USD'
  },
  'VU': {
    'name': 'Vanuatu',
    'placeId': 'ChIJE2CSyF5giW4RaibQvs85gzQ',
    'currency': 'USD'
  },
  'WF': {
    'name': 'Wallis and Futuna',
    'placeId': 'ChIJPUsabgaxyHERGwrSj-wYyRY',
    'currency': 'USD'
  },
  'WS': {
    'name': 'Samoa',
    'placeId': 'ChIJAxDsZKMTpXERcnhhdJYMh6Y',
    'currency': 'USD'
  },
  'YE': {
    'name': 'Yemen',
    'placeId': 'ChIJX7w0fKzbAxYRrneufjcp8ZI',
    'currency': 'USD'
  },
  'YT': {
    'name': 'Mayotte',
    'placeId': 'ChIJu43y3DMOCiIRSyr-lWcXMv8',
    'currency': 'USD'
  },
  'ZA': {
    'name': 'South Africa',
    'placeId': 'ChIJURLu2YmmNBwRoOikHwxjXeg',
    'currency': 'ZAR'
  },
  'ZM': {
    'name': 'Zambia',
    'placeId': 'ChIJcQv8_KX0QBkRRT5Yfqz5n_E',
    'currency': 'USD'
  },
  'ZW': {
    'name': 'Zimbabwe',
    'placeId': 'ChIJYXGxBuekMRkR7r_LxV84wKE',
    'currency': 'USD'
  },
  'CD': {
    'name': 'Democratic Republic of the Congo',
    'placeId': 'ChIJvUZ1ms_6eRkRQfGTrF4-xgQ',
    'currency': 'USD'
  },
  'DM': {
    'name': 'Dominica',
    'placeId': 'ChIJFVoV8vrSFIwRPP06BQmRs0k',
    'currency': 'USD'
  },
  'NE': {
    'name': 'Niger',
    'placeId': 'ChIJXa-hxnrsmRER1CSOFQqSM8k',
    'currency': 'USD'
  },
  'VI': {
    'name': 'US Virgin Islands',
    'placeId': 'ChIJuaza8mUQBYwRBRzFGx2JHfk',
    'currency': 'USD'
  },
  'BO': {
    'name': 'Bolivia',
    'placeId': 'ChIJlaK7d4nfXpERv-0VAbvCnhw',
    'currency': 'USD'
  },
  'FK': {
    'name': 'Falkland Islands (Islas Malvinas)',
    'placeId': 'ChIJo-ORRLmJKrwROsXZjf-qKjI',
    'currency': 'USD'
  },
  'FM': {
    'name': 'Micronesia',
    'placeId': 'ChIJE8hYrMW12WURJWWk-s2NelQ',
    'currency': 'USD'
  },
  'IR': {
    'name': 'Iran',
    'placeId': 'ChIJ8R1rwS7s9z4RzvpRntOVsEA',
    'currency': 'USD'
  },
  'KP': {
    'name': 'North Korea',
    'placeId': 'ChIJN0NP5toCfjURHIYdPhyHCzo',
    'currency': 'USD'
  },
  'MF': {
    'name': 'St Martin',
    'placeId': 'ChIJ_U5xCKxvDowRp4huTgqDGbk',
    'currency': 'USD'
  },
  'MK': {
    'name': 'Macedonia (FYROM)',
    'placeId': 'ChIJCUi8cJ8VVBMRscUfyNZa8uA',
    'currency': 'EUR'
  },
  'SX': {
    'name': 'Sint Maarten',
    'placeId': 'ChIJw5D41mJuDowRQo8zJsIsi3I',
    'currency': 'USD'
  },
  'TW': {
    'name': 'Taiwan',
    'placeId': 'ChIJL1cHXAbzbjQRaVScvwTwEec',
    'currency': 'USD'
  },
  'TZ': {
    'name': 'Tanzania',
    'placeId': 'ChIJEaFpSDFRSxgRMMTBSzEXWog',
    'currency': 'USD'
  },
  'VE': {
    'name': 'Venezuela',
    'placeId': 'ChIJAdjLNstTKIwR003VfFjyoNw',
    'currency': 'USD'
  },
  'VG': {
    'name': 'British Virgin Islands',
    'placeId': 'ChIJzVNkK5xzBYwRPTvsse5woG0',
    'currency': 'USD'
  },
  'KR': {
    'name': 'South Korea',
    'placeId': 'ChIJm7oRy-tVZDURS9uIugCbJJE',
    'currency': 'USD'
  },
  'MD': {
    'name': 'Moldova',
    'placeId': 'ChIJoWm3KDZ8yUARy6xT36wZgSU',
    'currency': 'EUR'
  },
  'PS': {
    'name': 'Palestine',
    'placeId': 'ChIJ2b1miNLyHBURhvZm0QGgF-4',
    'currency': 'ILS'
  },
  'XK': {
    'name': 'Kosovo',
    'placeId': 'ChIJ8X2_VPN6UxMRkRfDq9_u_78',
    'currency': 'EUR'
  },
};



// WEBPACK FOOTER //
// ./app/src/constants/countries.js